<template>
  <v-navigation-drawer
    v-if="$route.meta && $route.meta.isFrontend == false"
    id="app-drawer"
    v-model="inputValue"
    app
    floating
    persistent
    :mini-variant="miniNav"
    mobile-break-point="991"
    width="260"
  >
    <v-img :src="image" height="100%">
      <!-- <v-layout class="fill-height" tag="v-list" column> -->
      <v-list
        class="pa-0"
        style="height: 60px; background-color: rgb(218 216 216 / 60%)"
      >
        <v-list-tile style="background: white">
          <v-icon v-if="!miniNav" @click="miniNav = !miniNav" color="black">
            mdi-chevron-left
          </v-icon>
          <v-icon v-if="miniNav" @click="miniNav = !miniNav" color="black">
            mdi-chevron-right
          </v-icon>
          <v-img v-if="!miniNav" :src="logo" height="60" width="150" contain />
        </v-list-tile>
      </v-list>
      <v-list
        class="pt-0"
        dense
        style="
          height: calc(100vh - 50px);
          top: -10px;
          position: relative;
          overflow-y: scroll;
          background-color: rgb(218 216 216 / 60%);
        "
      >
        <v-divider></v-divider>

        <v-list-tile
          class="v-list-item"
          color="#ed2224"
          :class="{
            miniNavListTile: miniNav,
          }"
          style="background-color: red; border-radius: 5px"
          @click="$store.dispatch('user/logout')"
        >
          <v-list-tile-action>
            <v-icon color="black">mdi-lock</v-icon>
          </v-list-tile-action>
          <v-list-tile-content v-if="!miniNav">
            <v-list-tile-title
              style="position: relative !important; top: -3px !important"
              >Logout</v-list-tile-title
            >
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile
          v-for="(link, i) in links"
          :key="i"
          :to="link.to"
          :active-class="color"
          class="v-list-item"
          :class="{
            miniNavListTile: miniNav,
          }"
        >
          <v-list-tile-action>
            <v-icon
              style="opacity: 100% !important"
              :color="link.iconColor ? link.iconColor : 'black'"
              >{{ link.icon }}</v-icon
            >
          </v-list-tile-action>
          <v-list-tile-content v-if="!miniNav">
            <v-list-tile-title
              :class="{ activeText: $route.path == link.to ? true : false }"
              style="position: relative !important; line-height: 15px"
              >{{ link.text }}
              <v-chip
                style="height: 10px !important; width: 10px !important"
                small
                color="red"
                v-if="link.actionNotificationIcon && actions.length > 0"
              ></v-chip>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <!-- <v-divider /> -->
    </v-img>
  </v-navigation-drawer>
</template>

<script>
  // Utilities
  import { mapMutations, mapGetters, mapState } from "vuex";

  export default {
    data: () => ({
      miniNav: false,
      logo: "/img/upstream-logo-compact.png",
      links: [],
      generalLinks: [
        {
          to: "/",
          icon: "mdi-home",
          text: "Home",
        },
        {
          to: "/admin/dashboard",
          icon: "mdi-view-dashboard",
          text: "My Dashboard",
        },
      ],
      businessLinks: [
        {
          to: "/admin/salesEnquiry",
          icon: "mdi-email",
          text: "Your Enquiries",
          iconColor: "#4cc7e8",
        },
      ],
      impactBusinessLinks: [
        // {
        //   to: "/admin/myEnquiries",
        //   icon: "mdi-email",
        //   text: "Your Purchases (Buyer)",
        //   iconColor: "#325181",
        // },
      ],
      goodCauseLinks: [
        {
          to: "/admin/gcEnquiries",
          icon: "mdi-email",
          text: "Enq. Benefitting (G.C)",
          iconColor: "#68c6b3",
        },
      ],
      businessORImpactBusiness: [
        {
          to: "/admin/yourProfile",
          icon: "mdi-card-text",
          text: "Your Profile",
        },
      ],
      adminLinks: [
        {
          to: "/home",
          icon: "mdi-home",
          text: "Front End",
          iconColor: "",
        },

        {
          to: "/admin/actionCenter",
          icon: "mdi-format-list-checks",
          text: "Action Centre",
          iconColor: "orange",
          actionNotificationIcon: true,
        },
        {
          to: "/admin/salesEnquiry",
          icon: "mdi-currency-usd",
          text: "Sales Tracking",
          iconColor: "#ed2224",
        },
        {
          to: "/admin/leads",
          icon: "mdi-lightbulb-on",
          text: "Leads",
          iconColor: "#58595b",
        },
        {
          to: "/admin/ImpactBusinessAdmin",
          icon: "mdi-file-chart",
          text: "Impact Buyers",
          iconColor: "#325181",
        },
        {
          to: "/admin/salesTrackingStats",
          icon: "mdi-finance",
          text: "Statistics",
        },
        {
          to: "/admin/businesses",
          icon: "mdi-van-utility",
          text: "Suppliers",
          iconColor: "#4cc7e8",
        },
        {
          to: "/admin/GoodCauses",
          icon: "mdi-charity",
          text: "Good Causes",
          iconColor: "#68c6b3",
        },
        {
          to: "/admin/testimonials",
          icon: "mdi-comment-text",
          text: "Testimonials",
        },
        {
          to: "/admin/categories",
          icon: "mdi-file-tree",
          text: "Categories",
        },
        {
          to: "/admin/featuredListings",
          icon: "mdi-laptop",
          text: "Featured Listings",
        },
        {
          to: "/admin/users",
          icon: "mdi-account",
          text: "Users",
        },
        {
          to: "/admin/dashboard",
          icon: "mdi-view-dashboard",
          text: "Old Dashboard",
          iconColor: "",
        },
        {
          to: "/admin/orders",
          icon: "mdi-gift",
          text: "Impact Box Orders",
        },
      ],
      responsive: false,
    }),
    computed: {
      ...mapState("app", ["image", "color"]),
      ...mapGetters({ userData: "user/userData", actions: "actionCenter/list" }),
      inputValue: {
        get() {
          return this.$store.state.app.drawer;
        },
        set(val) {
          this.setDrawer(val);
        },
      },
      items() {
        return this.$t("Layout.View.items");
      },
    },
    watch: {
      userData: function (newUserData, oldUserData) {
        if (this.links.length < 1) {
          this.setLinks();
        }
      },
    },
    mounted() {
      this.onResponsiveInverted();
      window.addEventListener("resize", this.onResponsiveInverted);
      if (typeof this.userData.role != "undefined") {
        if (this.links.length < 1) {
          this.setLinks();
        }
      }
    },
    beforeDestroy() {
      window.removeEventListener("resize", this.onResponsiveInverted);
    },
    methods: {
      ...mapMutations("app", ["setDrawer", "toggleDrawer"]),
      onResponsiveInverted() {
        if (window.innerWidth < 991) {
          this.responsive = true;
        } else {
          this.responsive = false;
        }
      },
      setLinks() {
        // this.links = {};
        if (
          this.userData &&
          (this.userData.role.includes("Business") ||
            this.userData.role.includes("ImpactBusiness"))
        ) {
          this.generalLinks.forEach((element) => {
            this.links.push(element);
          });
        }
        if (this.userData && this.userData.role.includes("Business")) {
          this.businessLinks.forEach((element) => {
            this.links.push(element);
          });
        }

        if (this.userData && this.userData.role.includes("ImpactBusiness")) {
          this.impactBusinessLinks.forEach((element) => {
            this.links.push(element);
          });
        }

        if (this.userData && this.userData.role.includes("GoodCause")) {
          this.goodCauseLinks.forEach((element) => {
            this.links.push(element);
          });
        }

        if (this.userData && this.userData.role.includes("Admin")) {
          this.links = this.adminLinks;
        }
        if (
          this.userData &&
          (this.userData.role.includes("Business") ||
            this.userData.role.includes("ImpactBusiness"))
        ) {
          this.businessORImpactBusiness.forEach((element) => {
            this.links.push(element);
          });
        }
      },
    },
  };
</script>

<style lang="scss">
  #app-drawer {
    .v-list__tile {
      border-radius: 4px;

      &--buy {
        margin-top: auto;
        margin-bottom: 17px;
      }
    }

    .v-image__image--contain {
      top: 9px;
      height: 60%;
    }

    .search-input {
      margin-bottom: 30px !important;
      padding-left: 15px;
      padding-right: 15px;
    }
    .miniNavListTile {
      width: 60px;
    }
  }
</style>
<style>
  .activeText {
    color: black !important;
  }
</style>
